export const docListHeaders = [];

export const doctorHeaders = [
  "Name",
  // "Status",
  // "Availability",
  "Speciality",
  "Contact Details",
  "Action",
];

export const inclinicHeaders = [
  "Token No.",
  "Slot Timings",
  "Name",
  "Contact Details",
  "Checked-In At",
  "Category",
  "Status",
];

export const bookedHeaders = [
  // "Check-In OTP",
  "Token No.",
  "Name",
  "Contact Details",
  "Scheduled On",
  "Slot Timings",
  "Category",
  "Action",
];

export const completedHeaders = [
  "Name",
  "Contact Details",
  "Doctor",
  "Completed On",
  "Slot Timings",
  "Action",
];

export const cancelledHeaders = [
  "Name",
  "Contact Details",
  "Scheduled On",
  "Cancelled On",
  "Action",
];

export const dashAppointmentHeaders = [
  "Patient Name",
  "Doctor",
  "Contact Details",
];

export const appointmentHeaders = [
  "Name",
  "Doctor",
  "Booked Timings",
  "Contact Details",
  "Category",
  "Action",
];

export const allappointmentHeaders = [
  // "Check-In OTP",
  "Name",
  "Contact Details",
  "Primary Doctor",
  "Current Queue",
  "Check-In Time",
  "Booking Time",
  "Category",
  "Action",
];

export const allcancelappointmentHeaders = [
  "Name",
  "Contact Details",
  "Doctor",
  "Completed On",
  "Slot Timings",
  "Category",
  "Action",
];

export const cancelledTabHeaders = [
  "Name",
  "Contact Details",
  "Doctor",
  "Check-In Time",
  "Session",
  "Category",
  "Reason",
];

export const allpendingappointmentHeaders = [
  // "Check-In OTP",
  "Name",
  "Contact Details",
  "Date",
  "Doctor",
  "Booked Timings",
  // "Action",
];

export const patientHeaders = [
  "Name",
  "Contact Details",
  "Last Appointment",
  "Action",
];
export const allpatientHeaders = ["Name", "Contact Details", "Action"];

export const reportHeaders = [
  "Booking Date",
  "Uploaded On",
  "Doctor",
  "Action",
];

export const relationHeaders = [
  "Name",
  "Relationship Type",
  "Contact Details",
  "Action",
];
